export var YOSPACE_SSAI_PLUGIN_ID="@dicetechnology/doris-plugin-yospace-ssai";